var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.codeLines),function(line,index){return (_vm.step >= index + 2)?_c('prism',{key:line,staticClass:"code-block"},[_vm._v(_vm._s(line))]):_vm._e()}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }